import {
  ADMIRAL_LUCKY_TRIP_TRAVEL,
  IPolicy
} from '../data/api/models';


export const isLuckyTripProduct = (policy: IPolicy): boolean => {
  if (!policy) {
    return false;
  }
  return policy.productName === ADMIRAL_LUCKY_TRIP_TRAVEL
}

export const scrollToTop = () => {
  if (process.env.BROWSER) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
